import React from 'react';
import { TemplateBodyV3, TemplateContainer } from 'v3/shared/templates/styles';
import { IDefaultTemplateProps } from './types';

export const DefaultTemplate: React.FC<IDefaultTemplateProps> = ({ children }) => {
  return (
    <TemplateContainer>
      <TemplateBodyV3>{children}</TemplateBodyV3>
    </TemplateContainer>
  );
};
